import React from "react";

interface Props {
  title: any;
  value: any;
  subtext: string;
  onClick?: () => void; // Optional
}

const MetricCard: React.FC<Props> = ({ title, value, subtext, onClick }) => (
  <div
    className="cards"
    role="button"
    tabIndex={0}
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <h2>{title}</h2>
    <h3>{value}</h3>
    <p>{subtext}</p>
  </div>
);

export default MetricCard;
